import React, {useEffect, useState} from 'react';
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";
import {VisitRequestDto} from "../../../modules/vms/dto/VisitRequestDto";
import {useIntl} from "react-intl";
import {DictItemDto} from "../../../modules/dict/dto/DictItemDto";
import ApproveTimeLine from "../../workflow/flow/components/ApproveTimeLine";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import RequestPlaceList from "./RequestPlaceList";
import RequestVisitorDetail from "./RequestVisitorDetail";
import {Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import CloseButton from "../../../components/buttons/CloseButton";
import VisitRequestHostInfo from "./VisitRequestHostInfo";
import VisitorRequestInfo from "./VisitorRequestInfo";
import {MessageUtils} from "../../../utils/MessageUtils";
import {RequestVisitorApi} from "../../../modules/vms/api/RequestVisitorApi";
import LoadingBackdrop from "../../../components/LoadingBackdrop";
import RefreshButton from "../../../components/buttons/RefreshButton";

export type RequestVisitorDetailDialogProps = {
    open: boolean;
    requestVisitor: RequestVisitorDto;
    onClose: () => void;
    canApprove?: boolean;
    onApprove?: () => void;
    onReject?: () => void;
    onUpdatedVisitor?: () => void;
    onRefreshVisitor?: () => void;
    displayPlaceSpecial?: boolean;

};

// 扫码枪用到的变量
let code = "";
let lastTime = 0;
let nextTime = 0;
let lastCode = 0;
let nextCode = 0;

const RequestVisitorDetailDialog: React.FC<RequestVisitorDetailDialogProps> = (props) => {
    const intl = useIntl();

    // 访问目的
    const [purposeTypes, setPurposeTypes] = useState(new Array<DictItemDto>());

    // 证件类型
    const [idTypes, setIdTypes] = useState(new Array<DictItemDto>());

    // 访客类型
    const [visitorTypes, setVisitorTypes] = useState(new Array<DictItemDto>());

    // 驾驶类型
    const [driveTypes, setDriveTypes] = useState(new Array<DictItemDto>());

    // 车牌颜色
    const [plateNumberColors, setPlateNumberColors] = useState(new Array<DictItemDto>());

    // 车辆使用性质
    const [vehicleUseTypes, setVehicleUseTypes] = useState(new Array<DictItemDto>());

    // 车辆类型
    const [vehicleTypes, setVehicleTypes] = useState(new Array<DictItemDto>());
    // 员工实体
    const [employeeEntityTypes, setEmployeeEntityTypes] = useState(new Array<DictItemDto>());

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (props.open) {
            // 监听键盘事件以实现扫码直接签到
            window.addEventListener('keypress', _handleScanCheckin, false);
        }

        // 画面退出销毁倒计时
        return () => {
            window.removeEventListener('keypress', _handleScanCheckin, false);
        }
    }, [props.open]);

    const _handleScanCheckin = (e: KeyboardEvent) => {
        console.log(e);
        // e.which拿到的是keyCode
        nextCode = e.which;
        nextTime = new Date().getTime();

        if (lastCode != null && lastTime != null && nextTime - lastTime <= 500) {
            //时间短为扫码枪
            code += String.fromCharCode(lastCode);
        } else if (lastCode != null && lastTime != null && nextTime - lastTime > 500) {
            //普通手动键盘输入
            code = "";
        }
        console.log(code);

        lastCode = nextCode;
        lastTime = nextTime;
        //是否点击Enter键
        if (e.which === 13) {
            // code = "2ca0e63fc95b47c99c196835e009b93d";
            // 因为回车符不是""，会导致后台服务被调用，所以加上trim方法过滤掉再判断
            if (code !== "" && code.length === 4) {
                _handleCheckinRegister(code);
            }
            //清空code
            code = "";
        }
    }

    const _handleCheckinRegister = async (cardNumber: string) => {
        setIsLoading(true);
        props.requestVisitor.accessCardNumber = cardNumber;
        const responseResult = await RequestVisitorApi.checkinRegister(props.requestVisitor);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL'}));
            props.onClose();
            if (props.onUpdatedVisitor) {
                props.onUpdatedVisitor();
            }
        }
        setIsLoading(false);
    }

    const handleApprove = async () => {
        setIsLoading(true);
        const responseResult = await RequestVisitorApi.checkinApprove(props.requestVisitor.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'WORKFLOW_PROCESS_APPROVE_SUCCESS'}));
            if (props.onApprove) {
                props.onApprove();
            }
            props.onClose();
        }
        setIsLoading(false);
    }

    const handleReject = async (remarks: string) => {
        const responseResult = await RequestVisitorApi.checkinReject(props.requestVisitor.id, remarks);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'WORKFLOW_PROCESS_REJECT_SUCCESS'}));
            if (props.onReject) {
                props.onReject();
            }
            props.onClose();
        }
    }

    return (
        <Dialog open={props.open} fullWidth={true} maxWidth={'lg'}>
            <LoadingBackdrop open={isLoading} onClick={() => setIsLoading(false)}/>
            <DialogTitle>
                {intl.formatMessage({id: 'VMS_REQUEST_VISITOR_DETAIL'})}
            </DialogTitle>
            <DialogContent>
                {/*<br/>*/}
                {/*访客基本信息*/}
                <RequestVisitorDetail requestVisitor={props.requestVisitor} visitorTypes={visitorTypes}
                                      idTypes={idTypes}
                                      driveTypes={driveTypes} plateNumberColors={plateNumberColors}
                                      vehicleUseTypes={vehicleUseTypes} vehicleTypes={vehicleTypes}/>
                <br/>

                {props.displayPlaceSpecial ?
                    <RequestPlaceList displayPlaceSpecial={props.displayPlaceSpecial}
                        places={props.requestVisitor.visitRequest ? props.requestVisitor.visitRequest.places : []}/>
                    : <VisitorRequestInfo requestVisitor={props.requestVisitor}
                                        visitRequest={props.requestVisitor.visitRequest || new VisitRequestDto()}
                                        onUpdatedVisitor={() => {
                                            if (props.onUpdatedVisitor) {
                                                props.onUpdatedVisitor();
                                                props.onClose();
                                            }
                                        }}/>
                }
                {/*申请和接待者信息*/}
                <br/>
                <VisitRequestHostInfo visitRequest={props.requestVisitor.visitRequest || new VisitRequestDto()}
                                      employeeEntityTypes={employeeEntityTypes}
                                      purposeTypes={purposeTypes}/>
                <br/>
                {props.displayPlaceSpecial ?
                    <VisitorRequestInfo requestVisitor={props.requestVisitor}
                                        visitRequest={props.requestVisitor.visitRequest || new VisitRequestDto()}
                                        onUpdatedVisitor={() => {
                                            if (props.onUpdatedVisitor) {
                                                props.onUpdatedVisitor();
                                                props.onClose();
                                            }
                                        }}/>
                    : <RequestPlaceList
                        places={props.requestVisitor.visitRequest ? props.requestVisitor.visitRequest.places : []}/>
                }
                <br/>
                {/*审批信息*/}
                <Card>
                    <CardHeader title={intl.formatMessage({id: 'WORKFLOW_PROCESS_DETAIL'})}/>
                    <CardContent>
                        <ApproveTimeLine context={props.requestVisitor.requestId}
                                         onApprove={handleApprove}
                                         onReject={(remarks: string) => handleReject(remarks)}
                                         canApprove={props.canApprove}/>
                        <br/>
                        <ApproveTimeLine context={props.requestVisitor.id}
                                         onApprove={handleApprove}
                                         onReject={(remarks: string) => handleReject(remarks)}
                                         canApprove={props.canApprove}/>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                {props.onRefreshVisitor && <RefreshButton onClick={props.onRefreshVisitor}/>}
                <CloseButton onClick={props.onClose}/>
            </DialogActions>
        </Dialog>
    );
};

export default RequestVisitorDetailDialog;
